import { ComponentIdSpan } from "@inter-ikea-core/core";
const STORAGE2_BASE_ID = ComponentIdSpan.CORE_TOOLBOX_BASE_ID + 1000;
export const COMPONENT_IDS = {
    REMOVE_LEFT_SIDE_UNIT_ID: STORAGE2_BASE_ID,
    REMOVE_RIGHT_SIDE_UNIT_ID: STORAGE2_BASE_ID + 1,
    LEFT_SIDE_ATTACHED_TO: STORAGE2_BASE_ID + 2,
    RIGHT_SIDE_ATTACHED_TO: STORAGE2_BASE_ID + 3,
    CALCULATE_CROSS_BRACE: STORAGE2_BASE_ID + 4,
    REMOVED_CROSS_BRACE: STORAGE2_BASE_ID + 5,
    REPLACE_ENTITY: STORAGE2_BASE_ID + 6,
    ENTITY_IS_REPLACING: STORAGE2_BASE_ID + 7,
    INSERT: STORAGE2_BASE_ID + 8,
    STABILITY_ZONES: STORAGE2_BASE_ID + 9,
    SECTION_COMPONENT: STORAGE2_BASE_ID + 10,
    HEIGHT_RESTRICTED_COMPONENT: STORAGE2_BASE_ID + 11,
    BLOCK_CONNECTION_HOLE_COMPONENT: STORAGE2_BASE_ID + 12,
    MOUNTING_RAIL_CONTAINER_COMPONENT: STORAGE2_BASE_ID + 13,
    ADD_MOUNTING_RAIL: STORAGE2_BASE_ID + 14,
    UPRIGHT_COMPONENT: STORAGE2_BASE_ID + 15,
    MOUNTING_RAIL_COMPONENT: STORAGE2_BASE_ID + 16,
    OCCUPIED_HOLES_COMPONENT: STORAGE2_BASE_ID + 17,
    HOLES_DEMANDED_COMPONENT: STORAGE2_BASE_ID + 18,
    NON_WORLDLY_ITEM_COMPONENT: STORAGE2_BASE_ID + 19,
    ORGANIZERS_COMPONENT: STORAGE2_BASE_ID + 20,
    REQUEST_DESTRUCTION_COMPONENT: STORAGE2_BASE_ID + 21,
    CHANGE_ENTITY_ROOT_COMPONENT: STORAGE2_BASE_ID + 22,
    COLOR_COMPONENT: STORAGE2_BASE_ID + 23,
    PRODUCT_TYPE_COMPONENT: STORAGE2_BASE_ID + 24,
    RESIZE_COMPONENT: STORAGE2_BASE_ID + 25,
    REQUEST_MERGE_COMPONENT: STORAGE2_BASE_ID + 24,
    PROHIBITED_REPLACE_COMPONENT: STORAGE2_BASE_ID + 25,
    ADJUSTABLE_COMPONENT: STORAGE2_BASE_ID + 26,
    REQUIRE_SIZE_ADJUSTMENT_COMPONENT: STORAGE2_BASE_ID + 27,
    ADJUSTABLE_STATE_COMPONENT: STORAGE2_BASE_ID + 28,
    INSERT_ATTACHMENT_COMPONENT: STORAGE2_BASE_ID + 29,
    ROOM_CHANGED_COMPONENT: STORAGE2_BASE_ID + 30,
    MERGEABLE_COMPONENT: STORAGE2_BASE_ID + 31,
};
